@if (alert) {
<div class="wrapper">
  <div class="prop">
    <b>{{ "COLUMNS.NAME" | translate }}: </b>{{ alert.Name }}
  </div>
  <div class="prop">
    <b>{{ "COLUMNS.SOURCE" | translate }}: </b>{{ alert.PersonName }}
  </div>
  <div class="prop" *ngIf="alert.Description">
    <b>{{ "COLUMNS.DESCRIPTION" | translate }}: </b>{{ alert.Description }}
  </div>
  <div class="prop" *ngIf="alert.GroupName">
    <b>{{ "COLUMNS.GROUP" | translate }}: </b>{{ alert.GroupName }}
  </div>
  <div class="prop" *ngIf="alert.DepartmentName">
    <b>{{ "COLUMNS.DEPARTMENT" | translate }}: </b>{{ alert.DepartmentName }}
  </div>
  <div class="prop" *ngIf="alert.DeviceUniqueId">
    <b>{{ "COLUMNS.DEVICE_ID_UNIQUE" | translate }}: </b>{{ alert.DeviceUniqueId }}
  </div>
  <div class="prop" *ngIf="alert.EventTime">
    <b>{{ "COLUMNS.EVENT_DATETIME" | translate }}: </b>{{ alert.EventTime  | date: 'yyyy-MM-dd hh:mm:ss a' }}
  </div>
  <div class="prop" *ngIf="alert.EndDateTime">
    <b>{{ "COLUMNS.END_DATETIME" | translate }}: </b>{{ alert.EndDateTime  | date: 'yyyy-MM-dd hh:mm:ss a' }}
  </div>
  <div class="list" *ngIf="alert.EventActions.length"> <!-- look into use -->
    @for (action of alert.EventActions; track action) {
    <div class="key-value">{{ action.ActionComment }}</div>
    }
  </div>
</div>
} @else {
<mat-spinner></mat-spinner>
}
